import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import { IoCloseSharp } from "react-icons/io5";
import { SetCookies } from "../../_helpers/Cookies";

export const AppDownloadModal = ({ show, onHide }) => {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const handleClose = () => {
        if (dontShowAgain) {
            localStorage.setItem("hideAppDownloadModal", "true");
            SetCookies("hideAppDownloadModal","true")
        }
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
            contentClassName="custom-modal-content"
        >
            <Modal.Body className="text-center px-8">
                <div className="row">
                    <div className="text-right col-12"><IoCloseSharp className="font-size-h1 mb-0 cursor-pointer"  onClick={handleClose} /></div>
                </div>
                <div className="row align-items-center mt-4">
                    <div className="col-md-5">
                        <img
                            className="img-fluid"
                            src={toAbsoluteUrl(`media/General/AppImage.png`)}
                            alt="AppImage"
                        />
                    </div>
                    <div className="col-md-7">
                        <div className="">
                            <div className="display-4 font-weight-bold text-left text-warning">DOC Supplier Center </div>
                            <div className="display-4 font-weight-bold text-left mt-1">APP is LIVE!</div>
                        </div>
                        <div class="font-size-h6 mt-5 text-left text-muted">
                            The fastest way to list, sell, and manage your diamond orders - anytime, anywhere.
                        </div>
                        <div className="d-flex mt-5 justify-md-content-center">
                            <div className="d-flex justify-content-center flex-column mr-8">
                                
                                <a href="https://play.google.com/store/apps/details?id=com.diamondsoncall.seller" rel="noreferrer" target="_blank">
                                    <img
                                        className="img-fluid"
                                        src={toAbsoluteUrl(
                                            `media/General/GooglePlay.png`
                                        )}
                                        alt="GooglePlay"
                                    />
                                </a>
                                <a href="https://apps.apple.com/in/app/doc-seller-diamond-marketplace/id6744265378" rel="noreferrer" target="_blank">
                                    <img
                                        className="img-fluid mt-3"
                                        src={toAbsoluteUrl(
                                            `media/General/AppStore.png`
                                        )}
                                        alt="AppStore"
                                    />
                                </a>
                            </div>
                            <div >
                                <SVG
                                height={101}
                                width={101}
                                    src={toAbsoluteUrl(
                                        `media/General/AppQr.svg`
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-8">
                    <div class="checkbox-list">
                        <label class="checkbox">
                            <input type="checkbox" checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} name="Checkboxes1"/>
                            <span></span>
                            Don't show me again
                        </label>
                    </div>
                    <butto className="btn btn-clear font-weight-bold text-primary" onClick={handleClose}>
                        Skip
                    </butto>
                </div>
            </Modal.Body>
        </Modal>
    );
};
